import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Dimmer,
  Form,
  Grid,
  Header,
  Icon,
  Loader,
  Segment,
  Table,
} from "semantic-ui-react";
import useApiPangeo from "../../hooks/useApiPangeo";
import ListaVisitas from "./ListaVisitas";
import { voltarOuDashboard } from "../../utils/navegacao";


function encodeValor(anyVal) {
  if (Array.isArray(anyVal)) {
    return anyVal.join(",");
  }
  return anyVal;
}

function encodeUrl(object) {
  return Object.keys(object)
    .map((k) => `${k}=${encodeValor(object[k])}`)
    .join("&");
}

function Visitas() {
  const { search } = useLocation();
  const { data, isLoading, getVisita } = useApiPangeo();
  const [subregiSelecionada, setSubregiSelecionada] = useState();
  const navigate = useNavigate();

  const [status, setStatus] = useState();

  useEffect(() => {
    const searchParams = new URLSearchParams(search);
    setStatus(searchParams.get("status") || "");
    getVisita({ status: searchParams.get("status") });
  }, [getVisita, search]);

  const selecionaRegional = (regiSubregi) => {
    setSubregiSelecionada(regiSubregi);
  };

  const changeFiltro = (searchNovo = null) => {
    navigate({
      pathname: `/visitas`,
      search: `?${searchNovo || ""}`,
    });
  };

  const changeStatusFiltro = (e, data) => {
    const { value, checked } = data;

    let newStatus = status?.split(",") || [];

    if (checked) {
      newStatus.push(value);
    } else {
      newStatus = newStatus.filter((s) => s !== value);
    }

    changeFiltro(encodeUrl({ status: newStatus }));
  };

  return (
    <div>
      <div className="clearfix">
        <Header as="h3" style={{ float: "left" }}>
          Visitas por regional no mês
        </Header>
        <div className="breadcrumb-com-voltar">
          <Button basic size="small" onClick={() => voltarOuDashboard(navigate)}>
            Voltar
          </Button>
          <Breadcrumb>
          <Breadcrumb.Section to="/" link as={Link}>
            Home
          </Breadcrumb.Section>
          <Breadcrumb.Divider />
          <Breadcrumb.Section active>Visitas</Breadcrumb.Section>
          </Breadcrumb>
        </div>
      </div>

      <Form>
        <Form.Group>
          <Form.Input label="Status">
            <div className="inline-checkbox">
              <Checkbox
                label="Realizada"
                value="R"
                checked={status?.includes("R")}
                onChange={changeStatusFiltro}
              />
              <Checkbox
                label="Agendada"
                value="A"
                checked={status?.includes("A")}
                onChange={changeStatusFiltro}
              />
            </div>
          </Form.Input>
        </Form.Group>
      </Form>

      <Grid>
        <Grid.Row stretched>
          <Grid.Column mobile={16} computer={6}>
            <Segment className="tabela-com-detalhes">
              <Dimmer active={isLoading} inverted>
                <Loader>Aguarde ...</Loader>
              </Dimmer>
              <Table basic="very" unstackable celled collapsing className="dnxTable">
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>Regional</Table.HeaderCell>
                    <Table.HeaderCell>Qtd. visitas no mês</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {data?.items?.map((regional) => (
                    <Table.Row key={`${regional.regi}.${regional.subregi}`}>
                      <Table.Cell data-label="Regional">
                        <Header as="h4" image>
                          <Header.Content>
                          <Button
                              icon
                              circular
                              onClick={() =>
                                selecionaRegional(
                                  `${regional.regi}.${regional.subregi}`
                                )
                              }
                              positive={
                                `${regional.regi}.${regional.subregi}` ===
                                subregiSelecionada
                              }
                            >
                              <Icon
                                name={
                                  `${regional.regi}.${regional.subregi}` ===
                                  subregiSelecionada
                                    ? "check"
                                    : "plus"
                                }
                              />
                            </Button>
                            {regional.descricao}</Header.Content>
                        </Header>
                      </Table.Cell>
                      <Table.Cell data-label="Quantidade">{regional.quantidade}</Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
                <Table.Footer>
                  <Table.Row>
                    <Table.HeaderCell></Table.HeaderCell>
                    <Table.HeaderCell>
                      {data?.items?.reduce(
                        (accumulator, regi) => accumulator + regi.quantidade,
                        0
                      )}
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Footer>
              </Table>
            </Segment>
          </Grid.Column>
          <Grid.Column mobile={16} computer={10}>
          {subregiSelecionada ? (
              <ListaVisitas subregi={subregiSelecionada} statusList={status}/>
            ) : null}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  );
}

export default Visitas;
